<template>
  <div>
    <v-card>
      <div class="pa-4">
        <v-row
          no-gutters
          class="align-center"
          :class="{ 'mb-4' : $vuetify.breakpoint.smAndDown }"
        >
          <div
            :class="
              $vuetify.breakpoint.xs
                ? 'd-flex mx-1 my-2'
                : 'd-flex align-start'
            "
            :style="$vuetify.breakpoint.xs && 'width: 100%;'"
          >
            <v-icon :class="$vuetify.breakpoint.xs ? 'mr-2' : 'mr-4'" size="24">
              mdi-account-group
            </v-icon>
            <div
              :class="$vuetify.breakpoint.xs ? 'd-flex' : 'd-flex align-start'"
              style="width: 100%;"
            >
              <div
                :class="
                  $vuetify.breakpoint.xs
                    ? 'd-flex justify-space-between'
                    : 'd-flex flex-column'
                "
                style="width: 100%"
              >
                <strong class="mr-1"
                  >{{ $t("activeUsers") }}: {{ totalActivePlayers }}</strong
                >
                <strong v-if="!$vuetify.breakpoint.xs" class="mr-2">
                  {{ $t("minimum") }}: {{ minUsersToCommission }}
                </strong>
              </div>
              <div class="d-flex">
                <strong
                  v-if="$vuetify.breakpoint.xs"
                  class="mr-2"
                  style="white-space: nowrap;"
                >
                  {{ $t("minimum") }}: {{ minUsersToCommission }}
                </strong>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small color="info" v-bind="attrs" v-on="on">
                      <v-icon small>
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{
                      $tc(
                        "remainingActivePlayers",
                        reachedMinActivePlayersCommission,
                        {
                          remainingUsers: reachedMinActivePlayersCommission,
                        }
                      )
                    }}
                  </span>
                  <div class="mt-2">
                    <span>{{ $t("minPlayersCommissionTip") }}</span>
                  </div>
                </v-tooltip>
              </div>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="4" md="4">
            <div class="text-right">
              <v-text-field
                :class="{ 'mt-2' : $vuetify.breakpoint.smAndDown }"
                v-model="search"
                style="max-width: 600px"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                solo-inverted
                clearable
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-spacer class="my-2"></v-spacer>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          class="mb-4"
          :no-data-text="$t('noDataForthisQuery')"
          :no-results-text="$t('noDataForthisQuery')"
          :footer-props="{
            'items-per-page-text': $t('rowsPerPage'),
          }"
        >
          <template v-slot:item.nome_game="{ item }">
            <span>
              {{ item.nome_game }}
            </span>
          </template>

          <template v-slot:item.gross_value="{ item }">
            <div :class="getColor(item.gross_value)">
              {{ `${$t("labelCurrency")} ${addZeroes(item.gross_value)}` }}
            </div>
          </template>

          <template v-slot:item.value_ggr="{ item }">
            <div :class="getColor(item.value_ggr)">
              {{ `${$t("labelCurrency")} ${addZeroes(item.value_ggr)}` }}
            </div>
          </template>

          <template
            v-if="hasFeeValue"
            v-slot:item.fee_ggr_percentage="{ item }"
          >
            <div :class="getColor(item.fee_ggr_percentage * -1)">
              {{
                `${$t("labelCurrency")} ${addZeroes(item.fee_ggr_percentage)}`
              }}
            </div>
          </template>

          <template v-if="hasFeeValue" v-slot:item.value_ngr="{ item }">
            <div :class="getColor(item.value_ngr)">
              {{ `${$t("labelCurrency")} ${addZeroes(item.value_ngr)}` }}
            </div>
          </template>

          <template v-slot:item.prize_value="{ item }">
            <div :class="item.prize_value == 0 ? 'grey--text' : 'red--text'">
              {{ `${$t("labelCurrency")} ${addZeroes(item.prize_value)}` }}
            </div>
          </template>

          <template v-slot:item.affiliate_commission="{ item }">
            <div :class="getColor(item.affiliate_commission)">
              {{
                `${$t("labelCurrency")} ${addZeroes(item.affiliate_commission)}`
              }}
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div>
      <Resume
        :data_resume="{
          data,
          keys: [
            'gross_value',
            'prize_value',
            'value_ggr',
            ...(this.hasFeeValue ? ['fee_ggr_percentage', 'value_ngr'] : []),
            'affiliate_commission',
          ],
        }"
      />
      <div v-show="data.length > 0" class="caption text-center grey--text pt-4">
        GGR ({{ $t("grossValue") }} {{ $t("minus") }} {{ $t("prizesPaid") }}).
      </div>
    </div>
  </div>
</template>
<script>
import Resume from "@/components/backoffice/resume_global/resume";
import hasFeeValue from "@/util/hasFeeValue";

export default {
  name: "AgentFinancialRevenueShare",
  components: {
    Resume,
  },

  data: () => ({
    data: [],
    search: "",
    headerText: "",
    minUsersToCommission: 0,
    totalActivePlayers: 0,
  }),

  computed: {
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    gamingType() {
      return this.hasCasino
        ? this.$store.state.filters.gamingType.value
        : "sports";
    },

    hasCasino() {
      return (
        this.$store.state.operators && this.$store.state.operators.casino != "0"
      );
    },

    hasFeeValue() {
      return hasFeeValue;
    },

    headers() {
      let headers = [];

      if (this.gamingType === "casino") {
        headers = [
          {
            text: this.headerText,
            value: "nome_game",
          },
        ];
      } else {
        headers = [
          {
            text: this.headerText,
            value: "nome_game",
          },
        ];
      }

      headers.push(
        {
          text: this.$t("grossValue"),
          value: "gross_value",
        },
        {
          text: this.$t("periodSummaryPrizesPaid"),
          value: "prize_value",
        },
        {
          text: "GGR",
          value: "value_ggr",
        },
        ...(this.hasFeeValue
          ? [
              {
                text: this.$t("feeValue"),
                value: "fee_ggr_percentage",
              },
            ]
          : []),
        ...(this.hasFeeValue
          ? [
              {
                text: "NGR",
                value: "value_ngr",
              },
            ]
          : []),
        {
          text: this.$t("commissions"),
          value: "affiliate_commission",
        }
      );

      return headers;
    },

    reachedMinActivePlayersCommission() {
      return this.minUsersToCommission - this.totalActivePlayers <= 0
        ? 0
        : this.minUsersToCommission - this.totalActivePlayers;
    },
  },

  created() {
    this.$store.commit("setGamingType", { text: this.$t("all"), value: "all" });
    this.getComissions();
  },

  watch: {
    saveFilters(val) {
      val && this.getComissions();
    },
  },

  methods: {
    getComissions() {
      this.$request
        .post("/agent/financial/affiliateExtract", {
          data_inicio: this.rangeGlobalDate.date_start,
          data_final: this.rangeGlobalDate.date_final,
          type: this.gamingType,
        })
        .then((res) => {
          if (res.status === 200) {
            this.data = res.data.dados;

            this.data.forEach((item) => {
              if (!item.nome_game) {
                item.nome_game =
                  this.gamingType === "all"
                    ? this.$t("casinoAndBetting")
                    : this.$t("sportsBetting");

                this.headerText = this.$t("gamingType");
              } else {
                this.headerText = this.$t("gameName");
              }
              const fee_ggr_percentage_calc =
                item.value_ggr * (item.affiliate_fee / 100);

              item.fee_ggr_percentage = (fee_ggr_percentage_calc > 0
                ? fee_ggr_percentage_calc
                : 0
              ).toFixed(2);

              item.total_active_players = parseFloat(item.total_active_players);
              item.min_active_players_to_commission = parseFloat(
                item.min_active_players_to_commission
              );

              this.totalActivePlayers = item.total_active_players;
              this.minUsersToCommission = item.min_active_players_to_commission;
            });
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    addZeroes(num) {
      if (typeof num !== "string") {
        num = num.toString();
      }

      const dec = num.split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      return Number(num).toFixed(len);
    },
  },
};
</script>
<style>
.v-tooltip__content {
  font-size: 14px !important;
  max-width: 256px !important;
  opacity: 1 !important;
  padding: 8px 12px;
}
</style>
